import { analytics } from '../config/firebase';
import { Analytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';

// Check if analytics tracking is allowed
const isAnalyticsAvailable = (): boolean => {
  // Analytics object must exist
  if (!analytics) return false;
  
  // Check if we're in development mode
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  // Check if we're on localhost
  const isLocalhost = 
    window.location.hostname === 'localhost' || 
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('192.168.');
  
  // Only track in production environments and non-localhost domains
  return !isDevelopment && !isLocalhost;
};

export const analyticsService = {
  // Track a custom event
  trackEvent: (eventName: string, eventParams?: Record<string, any>) => {
    try {
      if (isAnalyticsAvailable()) {
        logEvent(analytics as Analytics, eventName, eventParams);
      } else {
        // In development, log to console instead
        if (process.env.NODE_ENV === 'development') {
          console.debug('[DEV Analytics]', eventName, eventParams);
        }
      }
    } catch (error) {
      console.warn('Analytics event tracking failed:', error);
    }
  },

  // Set user ID for analytics
  setUserId: (userId: string | null) => {
    try {
      if (isAnalyticsAvailable() && userId) {
        setUserId(analytics as Analytics, userId);
      } else if (process.env.NODE_ENV === 'development' && userId) {
        console.debug('[DEV Analytics] Set User ID:', userId);
      }
    } catch (error) {
      console.warn('Analytics user ID setting failed:', error);
    }
  },

  // Set user properties
  setUserProperties: (properties: Record<string, any>) => {
    try {
      if (isAnalyticsAvailable()) {
        setUserProperties(analytics as Analytics, properties);
      } else if (process.env.NODE_ENV === 'development') {
        console.debug('[DEV Analytics] Set User Properties:', properties);
      }
    } catch (error) {
      console.warn('Analytics user properties setting failed:', error);
    }
  },

  // Predefined events
  events: {
    // Authentication events
    LOGIN: 'login',
    SIGN_UP: 'sign_up',
    LOGOUT: 'logout',
    PASSWORD_RESET: 'password_reset',

    // Playlist events
    PLAYLIST_CREATED: 'playlist_created',
    PLAYLIST_UPDATED: 'playlist_updated',
    PLAYLIST_DELETED: 'playlist_deleted',
    PLAYLIST_SHARED: 'playlist_shared',
    PLAYLIST_IMPORTED: 'playlist_imported',

    // Channel events
    CHANNEL_PLAYED: 'channel_played',
    CHANNEL_ERROR: 'channel_error',

    // UI events
    THEME_CHANGED: 'theme_changed',
    LANGUAGE_CHANGED: 'language_changed',
    SEARCH_PERFORMED: 'search_performed'
  }
}; 